import * as ActionTypes from '../ActionTypes';

const MyTimeConfigureInitialState = {
    isLoading: false,
    success: false,
    error: false,
    successMessage: "",
    errorMessage: ""
}

export const MyTimeConfigureReducer = function (state = MyTimeConfigureInitialState, action) {
    switch (action.type) {
        case ActionTypes.MY_TIME_CONFIGURE_GET_REQUEST:
            return {
                ...state,
                isLoading: true,
                success: false,
                successMessage: "",
                error: false,
                errorMessage: "",
                mytime_options: []
            };
        case ActionTypes.MY_TIME_CONFIGURE_GET_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                successMessage: action.payload?.message,
                mytime_options: action.payload?.data?.data
            };
        case ActionTypes.MY_TIME_CONFIGURE_GET_ERROR:
            return {
                ...state,
                isLoading: false,
                error: true,
                success: false,
                errorMessage: action.payload?.data?.error?.[0]?.message
            }
        case ActionTypes.MY_TIME_CONFIGURE_ADD_REQUEST:
            return {
                ...state,
                isLoading: true,
                success: false,
                error: false,
            };
        case ActionTypes.MY_TIME_CONFIGURE_ADD_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                successMessage: action.payload?.message,
                mytime_options: action.payload?.data?.data
            };
        case ActionTypes.MY_TIME_CONFIGURE_ADD_ERROR:
            return {
                ...state,
                isLoading: false,
                error: true,
                success: false,
                errorMessage: action.payload?.data?.error?.[0]?.message
            }
        case ActionTypes.MY_TIME_CONFIGURE_UPDATE_REQUEST:
            return {
                ...state,
                isLoading: true,
                success: false,
                error: false,
            };
        case ActionTypes.MY_TIME_CONFIGURE_UPDATE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                successMessage: action.payload?.message,
                mytime_options: action.payload?.data?.data
            };
        case ActionTypes.MY_TIME_CONFIGURE_UPDATE_ERROR:
            return {
                ...state,
                isLoading: false,
                error: true,
                success: false,
                errorMessage: action.payload?.data?.error?.[0]?.message
            }
        case ActionTypes.MY_TIME_CONFIGURE_DELETE_REQUEST:
            return {
                ...state,
                isLoading: true,
                success: false,
                error: false,
            };
        case ActionTypes.MY_TIME_CONFIGURE_DELETE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                successMessage: action.payload?.message,
                mytime_options: action.payload?.data?.data
            };
        case ActionTypes.MY_TIME_CONFIGURE_DELETE_ERROR:
            return {
                ...state,
                isLoading: false,
                error: true,
                success: false,
                errorMessage: action.payload?.data?.error?.[0]?.message
            }
        default:
            return state;
    }
}